export class LocationDetails {
    id: number;
    locationId: number;
    areaId?: number;
    countryId?: number;
    location: string;
    name: string;
    gomAreaId?: number;
    locationCodeID?: number;
}


// WEBPACK FOOTER //
// ./src/app/modules/validate-loss-data-submission/shared/entities/location.ts